import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import QueryString from "qs";
import { ReqMethods, ghl } from "../../../enums";
import { useAppServices } from "../../../hook/services";
import env from "../../../config";
function GHL() {
  const { search } = useLocation();
  const code = new URLSearchParams(search).get("code");
  const AppServices = useAppServices();
  const [Error, setError] = useState("");

  const associate = async (data, installType) => {
    const payload = {
      ...data,
      installType: installType,
    };

    const { response } = await AppServices.auth.integrate_subaccount_app({
      payload,
    });

    if (!response)
      return setError(
        "Something went wrong while integration, please try latter"
      );

    return setError("App Integrate Successfully");
  };

  const getLocation = async (creds) => {
    const payload = {
      method: ReqMethods.GET,
      path: `${ghl.APIs.v2.location(creds.locationId)}`,
      key: creds.access_token,
      refresh_token: creds.refresh_token,
    };
    // console.log(payload)
    const { response } = await AppServices.services.ghl.call_service({
      payload,
    });

    if (!response)
      return setError(
        "Something went wrong while integration, please try latter"
      );
    // console.log(response.data)
    const location = response.data?.location;
    const data = {
      id: location?.id,
      name: location?.name,
      address: location?.address,
      city: location?.city,
      state: location?.state,
      country: location?.country,
      postalCode: location?.postalCode,
      website: location?.website,
      timezone: location?.timezone,
      firstName: location?.firstName,
      lastName: location?.lastName,
      email: location?.email,
      logoUrl: location?.logoUrl,
      phone: location?.phone,
      saasMode: location?.saasMode,
      productId: location?.productId,
      subscription_id: location?.subscription_id,
      subscriptionStatus: location?.subscriptionStatus,
      priceId: location?.priceId,
      customer_id: location?.customer_id,
      dateAdded: location?.dateAdded,
      access_token: creds?.access_token,
      refresh_token: creds?.refresh_token,
      company_id: creds?.refresh_token?.companyId,
    };
    return response && associate(data, "location");
  };

  const getCreds = async () => {
    const payload = {
      method: ReqMethods.POST,
      path: ghl.APIs.oauth,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      payload: QueryString.stringify({
        client_id: env.GHL.CLIENT_ID,
        client_secret: env.GHL.CLIENT_SECRET,
        grant_type: "authorization_code",
        code,
        refresh_token: "",
      }),
    };
    // console.log(payload)
    const { response } = await AppServices.services.ghl.call_service({
      payload,
    });

    if (!response)
      return setError(
        "Something went wrong while integration, please try latter"
      );

    return response && response.data?.locationId
      ? getLocation(response.data)
      : associate(response.data, "agency");
  };

  const onLoad = () => {
    getCreds();
  };

  useEffect(onLoad, []);

  return (
    <div>
      {!Error && <div>Integrating please wait...</div>}
      {Error && (
        <div>
          {Error}
          {/* <MDButton onClick={() => navigate(-2)}>Go Back</MDButton> */}
        </div>
      )}
    </div>
  );
}

export default GHL;
